import debounce from  "lodash/debounce";

export const saveTplChangesDebounced = debounce(
  (saveTplChanges, tplConfig, contentType) => {
    saveTplChanges.mutate({ tplConfig, contentType });
  },
  1000
);
